import React from 'react';

import { Card, Text } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { moment } from 'client/lib/moment';
import * as keyset from 'i18n/RevisionStatus';

const t = i18n(keyset);

import { Clock } from '@gravity-ui/icons';

import styles from './Notes.module.scss';

interface Props {
    publishedAt: string;
}

export const RevisionNote = ({ publishedAt }: Props) => {
    const dateString = moment(publishedAt).format('DD MMM YYYY, HH:mm');

    return (
        <Card className={styles.moderationNotesContainer} theme={'info'}>
            <Text className={styles.moderationHeader} color={'info-heavy'}>
                <Clock />
                {t('revision-from')}
                <span>{dateString}</span>
            </Text>
            <p className={styles.moderationText}>{t('revision-info')}</p>
        </Card>
    );
};
